//

// const bridge = require('./dsbridge')
import bridge from './dsbridge'
import store from './store'
import { setToken, removeToken } from './token'
import { isInNewJsBridgeApp, isInAppB, isInAppC } from './index';
import axDsbridge from '@anxin/dsbridge';
import { jsbNameObj } from './dsbridgeName.js';

function callBridge(options) {
  const {
    name,
    params,
    success,
    fail
  } = options
  const isApp = Boolean(
    window._dsbridge ||
    window._dswk ||
    navigator.userAgent.indexOf('_dsbridge') != -1
  )
  const isAxApp = Boolean(
    window._cjDsBridge ||
      window._cjDswk ||
      navigator.userAgent.indexOf("_cjDsBridge") != -1
  );
  // 如果在含有新版的Dsbridge的App里，则使用新的方法
  if (isAxApp && isInNewJsBridgeApp()) {
    const axNewName = jsbNameObj[name] || name;
    // 在新改版的 dsbridge 版本中，非新增的（原老方法[axNewName !== name]），B/C端不能调用非自己端的方法， 放过 CloudWorkbenchJsApi.setDocTitle
    if (axNewName !== name && isInAppB() && name.indexOf('CloudWorkbenchJsApi.setDocTitle') === -1 && name.indexOf('CloudWorkbenchJsApi') === -1) {
      console.log(name + " fail:在 B 端调用 C 端方法");
      fail && fail();
      return
    }
    if (axNewName !== name && isInAppC() && name.indexOf('CloudWorkbenchJsApi.setDocTitle') === -1 && name.indexOf('CloudWorkbenchJsApi') > -1) {
      console.log(name + " fail:在 C 端调用 B 端方法");
      fail && fail();
      return
    }
    axDsbridge.call(axNewName, params || {}, res => {
      console.log(axNewName + " success", res);
      if (res.status === 1) {
        success && success(res);
      } else {
        console.log(axNewName + " fail:", res);
        fail && fail(res);
      }
    });
  } else if (isApp) {
    bridge.call(name, params || {}, res => {
      console.log(name + ' success', res)
      success && success(res)
    })
  } else {
    console.log(name + " fail: it's not in App");
    fail && fail();
  }
}

/**
 * 跳转到原生页面
 */
export const navigateToNative = function (data) {
  callBridge({
    name: 'CloudWorkbenchJsApi.openNativeView',
    params: data,
    success: function () {},
    fail: function () {}
  });
};

export const getBUserInfo = function (successHandle, failureHandle) {
  callBridge({
    desc: "判断用户是否已经登录",
    name: "CloudWorkbenchJsApi.getBUserInfo",
    params: null,
    success: response => {
      if (typeof response === 'string') {
        try {
          response = JSON.parse(response)
        } catch (error) {
          response = {}
          console.error(error)
        }
      }

      if (response.status != 1) {
        return Promise.reject(response)
      }

      const data = response.data || {}
      // console.log(isLogin.token, 'getUserInfo');
      setToken(data.token);

      store.commit('SET_LOG_IN_STATIC', true);
      // localStorage.setItem('merchantNo', isLogin.merchantNo);
      // store.commit('SET_MERCHANT_NO', isLogin.merchantNo)
      successHandle && successHandle()
    },
    fail: (error) => {
      console.log('bridge注册失败, 失败原因:' + error)
      failureHandle && failureHandle();
    }
  });
};

export function setDocTitle(params, success, error) {
  return callBridge({
    name: 'CloudWorkbenchJsApi.setDocTitle',
    params,
    success: () => {},
    fail: () => {}
  })
}

// 发薪，考勤审核（拒绝，通过）之后，告诉客户端刷新页面
export function bdgUpdateCheckList(params, success, error) {
  return callBridge({
    name: 'CloudWorkbenchJsApi.updateCheckList',
    params,
    success: () => {},
    fail: () => {}
  })
}
// 关闭 webview
export function bdgCloseWebview(params, success, error) {
  return callBridge({
    name: 'CloudWorkbenchJsApi.closeWebview',
    params,
    success: () => {},
    fail: () => {}
  })
}
// 后退 webview
export function goBack(params, success, error) {
  return callBridge({
    name: 'CloudWorkbenchJsApi.goBack',
    params,
    success: () => {},
    fail: () => {}
  })
}

// 打开风险审核列表页面	 add on 2021/02/04
export function bdgOpenRiskCheckListPage(params, success, error) {
  return callBridge({
    name: 'CloudWorkbenchJsApi.openRiskCheckListPage',
    params,
    success: () => {},
    fail: () => {
      // 如果调用失败（老 APP），则直接关闭当前 webview；
      bdgCloseWebview();
      goBack();
    }
  })
}

// 设置标题栏字体及背景色颜色 add on 2021/02/04
export function bdgSetTitleBarColor(params, success, error) {
  return callBridge({
    name: 'CloudWorkbenchJsApi.setTitleBarColor',
    params,
    success: () => {},
    fail: () => {}
  })
}

// 日结员工详情
export function dailyStaffOperation(params, successCallback, error) {
  return callBridge({
    name: "CloudWorkbenchJsApi.dailyStaffOperation",
    params,
    success: response => {
      if (typeof response === "string") {
        try {
          response = JSON.parse(response);
        } catch (error) {
          response = {};
          console.error(error);
        }
      }

      if (response.status != 1) {
        return Promise.reject(response);
      }

      const data = response.data || {};
      successCallback && successCallback(data);
    },
    fail: () => {
      // 如果调用失败（老 APP），则直接关闭当前 webview；
      bdgCloseWebview();
      goBack();
    }
  });
}

// 打卡审核
export function punchCardAuditListPage(params, success, error) {
  return callBridge({
    name: 'CloudWorkbenchJsApi.punchCardAuditListPage',
    params,
    success: () => {},
    fail: () => {
      // 如果调用失败（老 APP），则直接关闭当前 webview；
      bdgCloseWebview();
      goBack();
    }
  })
}

// B端神策打点 add on 2021-02-27 周六
export function setSensorsPointB(params, success, error) {
  // return callBridge({
  //   name: 'CloudWorkbenchJsApi.setSensorsTrack',
  //   params,
  //   success: () => {},
  //   fail: () => {}
  // })
}

// B端退出登录 add on 2021-03-01
export function logoutB(params, success, error) {
  return callBridge({
    name: 'CloudWorkbenchJsApi.logout',
    params,
    success: () => {
      removeToken()
      location.reload();
    },
    fail: () => {}
  })
}

//  获取B端公共信息 add on 2021-03-02
export function getCommonInfoB(params, success, error) {
  return callBridge({
    name: 'CloudWorkbenchJsApi.getCommonInfo',
    params,
    success: (res) => {
      res = typeof res === 'string' ? JSON.parse(res) : res
      localStorage.setItem('AppVersion', res.data && res.data.version_name || '');
      success && success(res.data && res.data.version_code, res.data && res.data.version_name);
    },
    fail: () => {
      error && error()
    }
  })
}

// B端 iOS 获取步数
export function getHealthKitData(success, fail) {
  return callBridge({
    name: 'CloundPersonalJsApi.getHealthKitData',
    params: null,
    success,
    fail: () => {
      fail && fail()
    }
  })
}

//实名认证
export function getAuthentication(params,success, fail) {
  return callBridge({
    name: "CloundPersonalJsApi.loadVerifiedSdk",
    params: params,
    success,
    fail: () => {
      fail && fail();
    }
  });
}

//获取微信openId以及昵称
//params
export function getWXAuth(params, success, fail) {
  return callBridge({
    name: "CloundPersonalJsApi.loadWXAuthSdk",
    params: params,
    success,
    fail: () => {
      fail && fail();
    }
  });
}

//判断是否安装某个软件
export function getIsInstallApp(params, success, fail) {
  return callBridge({
    name: "AXCommonJsApi.getAppInstallStatus",
    params: params,
    success,
    fail: () => {
      fail && fail();
    }
  });
}
//判断是否安装微信
export function getIsInstallWx(params, success, fail) {
  return callBridge({
    name: "AXCommonJsApi.isWxInstall",
    params: params,
    success,
    fail: () => {
      fail && fail();
    }
  });
}
//打开微信小程序
export function openWxMini(params, success, fail) {
  return callBridge({
    name: "AXCommonJsApi.openWxMiniProgram",
    params: params,
    success,
    fail: () => {
      fail && fail();
    }
  });
}

//打卡审核详情 撤销审核刷新
export function updateInsuranceStaffList() {
  return callBridge({
    name: "CloundPersonalJsApi.updateInsuranceStaffList",
    params: null,
    success: () => {},
    fail: () => {}
  });
}
//打卡新页面 B端用的
export function openWebViewB(params, success, fail) {
  return callBridge({
    name: "AXCommonJsApi.openWebView",
    params,
    success: () => {},
    fail: () => {}
  });
}
